var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:none;stroke:#BABABA;stroke-width:2.2907;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#CFCFCF;}\n\t.st3{fill:#D2D2D2;}\n\t.st4{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.2907;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.6,102.2c-19.2,0-38.7-0.8-56.9-5.9c-17.9-5-34.4-14.6-49-25.8c-9.6-7.3-18.3-13-30.8-12.2 c-12.2,0.7-23.9,5.2-33.3,13.1c-15.9,13.7-13.5,39.5-7.1,57.5c9.5,27.2,38.5,46.1,63.2,58.4c28.5,14.2,59.8,22.5,91.1,27.2 c27.5,4.2,62.8,7.2,86.6-10.7c21.9-16.5,27.9-54.2,22.5-79.6c-1.3-7.5-5.3-14.3-11.2-19.1c-15.4-11.2-38.3-3.7-55.6-3.3 C221.6,102,215.1,102.2,208.6,102.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.7,259.2c46.4,0,84.1-2.4,84.1-5.2c0-2.9-37.6-5.2-84.1-5.2s-84.1,2.4-84.1,5.2 C77.6,256.8,115.2,259.2,161.7,259.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.6,74.2v9.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.6,79.1h9.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.1,157.2v9.8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.2,162.1h9.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.3,33.1V43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.4,38.1h9.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.7,10.3c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2C173.4,9.3,174.4,10.3,175.7,10.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.3,229.3c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2 C168.1,228.3,169.1,229.3,170.3,229.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M218.5,21L87.9,34.6c-3,0.3-5.1,3-4.8,6l17.9,172c0.3,3,3,5.2,6,4.8l130.6-13.6c3-0.3,5.1-3,4.8-6l-17.9-172 C224.2,22.9,221.5,20.7,218.5,21z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M212.9,28.9L95,41.2c-3,0.3-5.1,3-4.8,6l16.2,155.6c0.3,3,3,5.1,6,4.8l117.9-12.3c3-0.3,5.1-3,4.8-6L218.9,33.8 C218.5,30.8,215.9,28.6,212.9,28.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M192.6,36.6l-1.8-17.6c-0.1-0.7-0.5-1.4-1-1.9c-0.6-0.5-1.3-0.7-2-0.6l-21.8,2.3c-0.2-1.8-0.7-3.5-1.5-5 c-0.8-1.6-2-3-3.3-4.1c-1.4-1.1-2.9-2-4.6-2.5c-1.7-0.5-3.5-0.7-5.2-0.5c-1.8,0.2-3.5,0.7-5,1.5c-1.6,0.8-2.9,2-4.1,3.3 c-2.3,2.8-3.3,6.3-3,9.9l-21.9,2.3c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.4,0.6-0.5,1 c-0.1,0.4-0.1,0.7-0.1,1.1l1.8,17.6c0,0.4,0.1,0.7,0.3,1.1c0.2,0.3,0.4,0.6,0.7,0.8c0.3,0.2,0.6,0.4,1,0.5c0.4,0.1,0.7,0.2,1.1,0.1 l70.5-7.3c0.4,0,0.7-0.1,1.1-0.3c0.3-0.2,0.6-0.4,0.8-0.7c0.2-0.3,0.4-0.6,0.5-1C192.6,37.3,192.6,36.9,192.6,36.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.9,144.1c0.7-6.8,3.8-13.1,8.7-18c4.9-4.8,11.2-7.8,18-8.5c6.8-0.7,13.6,0.9,19.4,4.7 c5.7,3.7,10,9.3,12.2,15.8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.2,91.6l-11,13.5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127,92.9l13.5,10.9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.3,86.1l-11,13.5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180,87.4l13.5,11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTask);
export default __webpack_public_path__ + "static/media/no-task.685e9afe3b9b4fb0dc7034263300f603.svg";
export { ForwardRef as ReactComponent };